<template>
  <v-breadcrumbs :items="items">
    <template v-slot:divider>
      <v-icon>mdi-forward</v-icon>
    </template>
  </v-breadcrumbs>
</template>
<script>
export default {
  name: 'Breadcrumb',
  methods: {
    fillBreadcrumbMenu(menu, flat) {
      if (menu) {
        flat.unshift({
          text: this.$tc(menu.meta.title, 2),
          disabled: false,
          href: menu.path,
        })
        if (menu.parent) {
          flat.unshift(...this.fillBreadcrumbMenu(menu.parent, flat));
        }
        return flat.filter((item, index) => flat.indexOf(item) === index);
      }
    },
  },
  computed: {
    items() {
      let that = this,
          [menu] = this.$route.matched.filter((route) => route.path === that.$route.path);
      return this.fillBreadcrumbMenu(menu, []);
    }
  }
}
</script>